export default {"src":"/_next/static/media/text_strip_1.db15b753.svg","height":45,"width":54,"blurWidth":0,"blurHeight":0};